import { GzEasmCriticalVulnerabilitiesWebComponent } from './component/GzEasmCriticalVulnerabilitiesWebComponent';

export { GzEasmCriticalVulnerabilitiesWebComponent };
